export default function AffiliateDisclosure() {
  return (
    <footer className="social-footer">
      <p>
        A little note: Amazon and Lala Hijab are affiliate links. I may earn a
        commission when you shop through them. As an Amazon Associate I earn
        from qualifying purchases. Thank you for supporting my work.
      </p>
    </footer>
  );
}
